import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7C4DFF', // Purple for the brand color
    },
    background: {
      default: '#F5F7FA', // Light background
    },
    text: {
      primary: '#3A3A3A', // Dark text
      secondary: '#A3A3A3', // Lighter text for subtitles
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif', // Use a modern font like Poppins
    h4: {
      fontWeight: 600,
      fontSize: '1.8rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1.2rem',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '15px',
          boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)', // Subtle shadow
        },
      },
    },
  },
});

export default theme;